import React from "react";

/**
 * StatTableDrillDown — render any tabular ranking inside a DrillDownPanel.
 * Each column may declare `format(value)` and `mono: true`.
 */
export default function StatTableDrillDown({ rows = [], columns = [], emptyText = "Nothing to show." }) {
  if (!rows.length) {
    return (
      <p className="font-body text-sm text-muted" style={{ padding: "24px 0", textAlign: "center" }}>
        {emptyText}
      </p>
    );
  }
  return (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr style={{ borderBottom: "1px solid var(--glass-border-btm)" }}>
          {columns.map((c) => (
            <th
              key={c.key}
              className="font-body text-caps text-muted"
              style={{ textAlign: "left", padding: "6px 6px", fontWeight: 500 }}
            >
              {c.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i} style={{ borderBottom: "1px solid rgba(200,190,172,0.2)" }}>
            {columns.map((c) => (
              <td
                key={c.key}
                className={`text-sm ${c.mono ? "font-mono" : "font-body"}`}
                style={{ padding: "10px 6px", color: "var(--slate-700)" }}
              >
                {c.format ? c.format(row[c.key], row) : row[c.key] ?? "—"}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
